import { render, staticRenderFns } from "./ProceduresTabPage.vue?vue&type=template&id=2e3dc5ba"
import script from "./ProceduresTabPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProceduresTabPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProceduresTabPage.vue?vue&type=style&index=0&id=2e3dc5ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports